import React from 'react';
import { motion } from 'framer-motion';
import { Shield } from 'lucide-react';
export function Guarantee() {
  return <section className="py-7 px-5" data-id="element-182">
      <div className="max-w-lg mx-auto" data-id="element-183">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="bg-navy-800/50 border border-gold-500/20 p-5 sm:p-6 rounded-sm text-center relative overflow-hidden" data-id="element-184">
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-gold-500/50 to-transparent" data-id="element-185"></div>

          <div className="inline-flex items-center justify-center w-11 h-11 rounded-full bg-navy-900 border border-gold-500/30 mb-3 text-gold-400" data-id="element-186">
            <Shield size={22} strokeWidth={1.5} data-id="element-187" />
          </div>

          <h3 className="font-serif text-xl text-cream-100 mb-3" data-id="element-188">
            Garantía de Fe
          </h3>

          <div className="space-y-2 text-[13.5px] sm:text-[14px] text-cream-300/80 font-light leading-relaxed" data-id="element-189">
            <p data-id="element-190">
              Si en los primeros 7 días no sientes que este devocional está
              hablando directamente a tu historia y a tu momento... te
              devolvemos tu inversión completa. Sin preguntas. Sin trámites.
            </p>
            <p data-id="element-191">
              Porque no queremos tu dinero si no podemos cambiar tu perspectiva.
            </p>
            <p className="text-gold-400 font-medium pt-2" data-id="element-192">
              Así de seguros estamos de lo que Dios puso en estas páginas.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}